import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import Loading from '../../common/Loading'
import { cpfMask, cnpjMask, cepMask, foneMask, moneyMask } from '../../common/Mask'
import moment from 'moment';
import { dateUtils } from '../../common/DateUtils';

class Combo extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            filtros:[],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            isDisabled: true,
            id:'',
            data:'',
            hora:'',
            cliente:'',
            clientes:'',
            clienteDefault:'',
            grupo:'',
            grupos:'',
            grupoDefault:'',
            pagamento:'',
            pagamentos:'',
            pagamentoDefault:'',
            tipo: '',
            tipos: '',
            tipoDefault: '',
            solicitado:'',
            utilizado:'',
            unitario:'',
            total:'',
            dias_desde_antecipacao: '',
            nao_expirar: false,
            isValid: true,
            message: ''
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.calcular = this.calcular.bind(this);
        this.handleFiltroGrid = this.handleFiltroGrid.bind(this);

    }

    async Loading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        this.Loading(true)
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 24 })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/antecipada', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => { 
            this.Loading(false)          
            this.setState( { items : response.data, filtros: response.data } );
        })
        this.Loading(false)
    }

    add = async(item) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 24  })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
       
        const grupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        });

        let listarGrupoServico = [];
        grupos.data.forEach(element => {
            listarGrupoServico.push({value: element.id, label:element.nome })
        });


        const pessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        })

        let listarPessoas = [];
        pessoas.data.forEach(element => {
            if(element.tipo == 1 ) listarPessoas.push({value: element.id, label:element.razao })
        });

        const pagamentos = await api.get('/api/pagamento', {
            headers: {
                'x-access-token':token,
            }
        })

        let listarPagamentos = [];
        pagamentos.data.forEach(element => {
            listarPagamentos.push({value: element.id, label:element.nome })
        });

        const tipo = []
        tipo.push({value: 0, label: 'Selecione Tipo'})
        tipo.push({value: 1, label: 'Lavar/Passar'})
        tipo.push({value: 2, label: 'Apenas Lavar'})
        tipo.push({value: 3, label: 'Apenas Passar'})

        
        this.setState({
            isListagem: false, 
            isEdicao:true,
            isDisabled: true,
            id:'',
            data: '',
            hora:'',
            cliente:'',
            clientes:listarPessoas,
            clienteDefault:'',  
            grupo:'',
            grupos: listarGrupoServico,
            grupoDefault:[],
            pagamento:'',
            pagamentos: listarPagamentos,
            pagamentoDefault: [], 
            tipo:'',
            tipos:tipo,
            tipoDefault:[],
            solicitado:0,
            utilizado:0,
            unitario:0,
            total:0,    
            dias_desde_antecipacao: 0,
            nao_expirar: false     
        })

    }

    edit = async( id ) => {
        
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');

        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaServico        = permissoes.data.filter(function(value){ return value.idmenu  == 16  })
        if(empresaServico.length > 0 && empresaServico[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
       
        const grupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        });

        let grupoServico = [];
        let grupoDefault = []
        try {
            await api.get(`/api/antecipada/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(async response => {

                console.log(response)
                const grupos = await api.get('/api/gruposervico', {
                    headers: {
                        'x-access-token':token,
                    }
                });
                let listarDefaultGrupoServico = [];
                let listarGrupoServico = [];
                grupos.data.forEach(element => {
                    if( element.id == response.data[0].grupo) listarDefaultGrupoServico.push({value: element.id, label:element.nome })
                    listarGrupoServico.push({value: element.id, label:element.nome })
                });
        
        
                const pessoas = await api.get('/api/pessoa', {
                    headers: {
                        'x-access-token':token,
                    }
                })
        
                let listarDefaultPessoas = [];
                let listarPessoas = [];
                pessoas.data.forEach(element => {
                    if(element.id == response.data[0].cliente) listarDefaultPessoas.push({value: element.id, label:element.razao })
                    if(element.tipo == 1 ) listarPessoas.push({value: element.id, label:element.razao })
                });

                const pagamentos = await api.get('/api/pagamento', {
                    headers: {
                        'x-access-token':token,
                    }
                })
        
                let listarPagamentos = [];
                let listarDefaultPagamentos = [];
                pagamentos.data.forEach(element => {
                    if(element.id == response.data[0].pagamento) listarDefaultPagamentos.push({value: element.id, label:element.nome })
                    listarPagamentos.push({value: element.id, label:element.nome })
                });
        
                const tipo = []
                tipo.push({value: 0, label: 'Selecione Tipo'})
                tipo.push({value: 1, label: 'Lavar/Passar'})
                tipo.push({value: 2, label: 'Apenas Lavar'})
                tipo.push({value: 3, label: 'Apenas Passar'})
                const tipoDefault =Number(response.data[0].tipo) > 0 ? tipo[response.data[0].tipo] : []
        
                
                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    isDisabled: true,
                    id:response.data[0].id,
                    data: response.data[0].data,
                    hora:response.data[0].hora,
                    cliente:response.data[0].cliente,
                    clientes:listarPessoas,
                    clienteDefault:listarDefaultPessoas,  
                    grupo:response.data[0].grupo,
                    grupos: listarGrupoServico,
                    grupoDefault:listarDefaultGrupoServico,
                    pagamento:response.data[0].pagamento,
                    pagamentos: listarPagamentos,
                    pagamentoDefault:listarDefaultPagamentos,
                    tipo:response.data[0].tipo,
                    tipos:tipo,
                    tipoDefault:tipoDefault,
                    solicitado:response.data[0].solicitada,
                    utilizado:response.data[0].utilizado,
                    unitario:response.data[0].unitario,
                    total:response.data[0].total,
                    nao_expirar:response.data[0].nao_expirar || false         
                })
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/antecipada', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                codigo:'',
                nome:'',
                grupo:'',
                grupos: '',
                grupoDefault: '',
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id, tipo, grupo, cliente, solicitado, pagamento, utilizado, unitario, total, nao_expirar } = this.state
        const grupoPermissao     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        let data = new Date()
        let hora = moment(data).format("hh:mm")

        const permissoes = await api.get(`/api/permissao/${grupoPermissao}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 24   })
      
        try {
            
            if ( id ) {
        
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
       
                await api.put(`/api/antecipada/${id}`,{  tipo, data, hora, grupo, cliente, solicitado, utilizado, unitario, total, nao_expirar }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    await api.get('/api/antecipada', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                       
                        this.setState({
                            isListagem: false, 
                            isEdicao:true,
                            isDisabled: true,
                            id:'',
                            data: '',
                            hora:'',
                            cliente:'',
                            clientes:[],
                            clienteDefault:'',  
                            grupo:'',
                            grupos: [],
                            grupoDefault:[],
                            tipo:'',
                            tipos:tipo,
                            tipoDefault:[],
                            solicitado:'',
                            utilizado:'',
                            unitario:'',
                            total:'',
                            nao_expirar: false,
                            items : response.data,
                            filtros: response.data         
                        })
                       
                    })
                })
            } else {
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
                console.log("Entrou 01")
                await api.post('/api/antecipada',{ tipo, data, hora, grupo, cliente, pagamento, solicitado, utilizado, unitario, total, nao_expirar}, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    
                    await api.get('/api/antecipada', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            isDisabled: true,
                            id:'',
                            data: '',
                            hora:'',
                            cliente:'',
                            clientes:[],
                            clienteDefault:'',  
                            grupo:'',
                            grupos: [],
                            grupoDefault:[],
                            pagamento:'',
                            pagamentos: [],
                            pagamentoDefault:[],
                            tipo:'',
                            tipos:tipo,
                            tipoDefault:[],
                            solicitado:'',
                            utilizado:'',
                            unitario:'',
                            total:'',
                            nao_expirar: false,
                            items : response.data,
                            filtros: response.data         
                        })
                    })
                   
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 16   })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                const response = await api.delete(`/api/antecipada/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(async response => {
                    console.log(response)
                    await api.delete(`/api/antecipada/${id}`, {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        api.get('/api/antecipada', {
                            headers: {
                                'x-access-token':token,
                            }
                        }).then(response => {
                            this.setState( { items : response.data } );
                            toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                        });
                    });

                })


                
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }
    
    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/antecipada', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                data: '',
                hora:'',
                cliente:'',
                clientes:[],
                clienteDefault:'',  
                grupo:'',
                grupos: [],
                grupoDefault:[],
                pagamento:'',
                pagamentos: [],
                pagamentoDefault:[],
                tipo:'',
                tipos:'',
                tipoDefault:[],
                solicitado:'',
                utilizado:'',
                unitario:'',
                total:'', 
                dias_desde_antecipacao: '',           
                items : response.data    
            })
        })
    }

    calcular = async( event ) => {
        event.preventDefault();

        const token    = sessionStorage.getItem('token');
        const { id, tipo, grupo, cliente, solicitado, unitario, total } = this.state

        const promocao = await api.get('/api/promocao', {
            headers: {
                'x-access-token':token,
            }
        })
        let itensDePromocao;
        if(grupo) {

            itensDePromocao = promocao.data.filter(function (value) {
                return value.tipo == tipo && value.idgrupo == grupo &&
                (Number(solicitado) >= Number(value.inicial) &&
                Number(solicitado) < Number(value.final))
    
            });

            if(itensDePromocao.length) {

                this.setState({
                    unitario: Number(itensDePromocao[0].preco).toFixed(2),
                    total: Number( solicitado * itensDePromocao[0].preco).toFixed(2)
                })
            }
        } else {

            itensDePromocao = promocao.data.filter(function (value) {
                return value.tipo == tipo && value.idgrupo == null &&
                (Number(solicitado) >= Number(value.inicial) &&
                Number(solicitado) < Number(value.final))
            });

            if(itensDePromocao.length) {
                

                console.log(itensDePromocao)
                this.setState({
                    unitario: Number(itensDePromocao[0].preco).toFixed(2),
                    total: Number( solicitado * itensDePromocao[0].preco).toFixed(2)
                })
            }
        }
  
       
  
    }


    handleFiltroGrid = async (filterText) => {
        const { filtros, items } = this.state;
        this.Loading(true);
        const filtragem =
          filterText.length > 0
            ? items.filter((item) =>
                (
                  item.cliente +
                  "" +
                  item.grupo  
                 
                )
                  .toLowerCase()
                  .includes(filterText.toLowerCase())
              )
            : filtros;
        this.setState({ items: filtragem, filterText: filterText });
    
        this.Loading(false);
    };
    
    render() {
        const subHeaderComponentMemo = (
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar"
                  onChange={(e) => this.handleFiltroGrid(e.target.value)}
                />
                <div class="input-group-append">
                  <div class="btn btn-primary">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
          );

        const columns = [
            {
                name: 'Cliente',
                selector: 'cliente',
                sortable: true,
            },
            {
                name: 'Criado Em',
                selector: 'data',
                sortable: true,
                cell: (row) => dateUtils(row.data)
            },   
            {
                name: 'Dias',
                selector: 'dias_desde_antecipacao',
                sortable: true,
                cell: (row) => Number(row.dias_desde_antecipacao).toFixed(0)                  
            }, 
            {
                name: 'Expira Em',
                selector: '',
                sortable: true,
                cell: (row) => row.nao_expirar ? 'Sem prazo' : `${ (30-row.dias_desde_antecipacao).toFixed(0)} dias`                  
            }, 
            {
              name: 'Grupo',
              selector: 'grupo',
              sortable: true,
            },
            {
                name: 'Tipo',
                selector: 'tipo',
                sortable: true,
                cell: (row) => row.tipo == 1 ? 'Lavar/Passar' : row.tipo == 2 ? 'Lavar' : 'Passar'
            }, 
            {
                name: 'Pagamento',
                selector: 'pagamento',
                sortable: true,
            }, 
            {
                name: 'Solicitada',
                selector: 'solicitada',
                sortable: true,
            }, 
            {
                name: 'Utilizado',
                selector: 'utilizado',
                sortable: true,
            },             
            {
                name: 'Unitario',
                selector: 'unitario',
                sortable: true,     
                cell: (row) => Number(row.unitario).toFixed(2)   
            }, 
            {
                name: 'Total',
                selector: 'total',
                sortable: true,
                cell: (row) => Number(row.total).toFixed(2)                  
            },   
           
            
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];

        
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO SERVIÇOS</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                    subHeader
                                                    subHeaderComponent={subHeaderComponentMemo}
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                               
                                            </div>
                                          
                                            
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div class="form-group">
                                                        <label>Tipo</label>
                                                        <Select
                                                        id="tipo"
                                                        placeholder="Selecione"
                                                        options={this.state.tipos}
                                                        value={this.state.tipoDefault}
                                                        onChange={ e => this.setState({ tipoDefault: e, tipo: e.value, isDisabled: false })}
                                                        />
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Grupo</label>
                                                        <Select
                                                            id="grupo"
                                                            placeholder="Selecione" 
                                                            isSearchable="true"
                                                            isOptionSelected                                                            
                                                            options={ this.state.grupos }                   
                                                            value={this.state.grupoDefault}
                                                            onChange={ e => this.setState({grupo: e.value, grupoDefault:[{label: e.label, value: e.value }] })}
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="form-group">
                                                        <label>Cliente</label>
                                                        <Select
                                                        id="cliente"
                                                        placeholder="Selecione"
                                                       
                                                        options={this.state.clientes}
                                                        value={this.state.clienteDefault}
                                                        onChange={ e => this.setState({ clienteDefault: e, cliente: e.value })}
                                                        />
                                                    </div>


                                                    <div class="form-group">
                                                        <label>Pagamento</label>
                                                        <Select
                                                            id="pagamento"
                                                            placeholder="Selecione" 
                                                            isSearchable="true"
                                                            isOptionSelected                                                            
                                                            options={ this.state.pagamentos }                   
                                                            value={this.state.pagamentoDefault}
                                                            onChange={ e => this.setState({pagamento: e.value, pagamentoDefault:[{label: e.label, value: e.value }] })}
                                                        />
                                                    </div>

                                                    <div class="form-group">
                                                        <label>Solicitado</label>
                                                        <input
                                                        type="text"
                                                        id="solicitado"
                                                        name="solicitado"
                                                        class="form-control"
                                                       
                                                        placeholder="Informe a quantidade solicitada"
                                                        value={this.state.solicitado}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                solicitado: moneyMask(e.target.value),
                                                            })
                                                        }                                                      
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Utilizado</label>
                                                        <input
                                                        type="text"
                                                        id="Utilizado"
                                                        name="Utilizado"
                                                        class="form-control"
                                                       readOnly="true"
                                                        placeholder="Informe a quantidade solicitada"
                                                        value={this.state.utilizado}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                utilizado: e.value,
                                                            })
                                                        }                                                      
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <button type="button" className="btn btn-default pull-right" onClick={ this.calcular }>Calcular</button>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Unitario</label>
                                                        <input
                                                        type="text"
                                                        id="pago"
                                                        name="pago"
                                                        class="form-control"
                                                        placeholder="Informe o valor pago"
                                                        value={this.state.unitario}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                unitario: moneyMask(e.target.value),
                                                            })
                                                        }
                                                        readOnly="true"
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Total</label>
                                                        <input
                                                        type="text"
                                                        id="pago"
                                                        name="pago"
                                                        class="form-control"
                                                        placeholder="Informe o valor pago"
                                                        value={this.state.total}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                total: moneyMask(e.target.value),
                                                            })
                                                        }
                                                        readOnly="true"
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>
                                                            <input
                                                            type="checkbox"
                                                            checked={this.state.nao_expirar}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    nao_expirar: e.target.checked,
                                                                })
                                                            }
                                                            />
                                                            {' '}Não Expirar (Finaliza apenas quando acabar o estoque)
                                                        </label>
                                                    </div>
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                            <Loading isCarrega={ this.state.isLoading } />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Combo;